import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, LOCALE_ID,APP_INITIALIZER,ErrorHandler, Injector } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationConstants } from './shared/services/util/translation.constants';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { LayoutModule } from './shared/layout/layout.module';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { ApplicationInitializerFactory } from './translation.initializer';
import { CapacitorHttpProvider } from './interceptors/capacitor.http.provider';
import { AntifraudHttpInterceptor } from './interceptors/antifraud.http.interceptor';
import { PjAccountHttpInterceptor } from './interceptors/pj-account.http.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { App as CapacitorApp } from '@capacitor/app';
import { PixelModule } from 'ngx-pixel';
import { environment } from 'src/environments/environment';
import { ServicesModule } from './shared/services/services.module';
import { NgOtpInputModule } from 'ng-otp-input';

registerLocaleData(ptBr);

CapacitorApp.addListener('backButton', ({canGoBack}) => {
  if(!canGoBack){
    CapacitorApp.exitApp();
  } else {
    window.history.back();
  }
});

/**
 * Custom HTTP language loader
 *
 * @param httpClient The httpClient
 */
export function LangHttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(httpClient, './../i18n/', '.json');
}

@NgModule({
    declarations: [ AppComponent ],
    imports: [
        NgOtpInputModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: LangHttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        AppRoutingModule,
        environment.pixelId !== '' ? PixelModule.forRoot({ enabled: true, pixelId: environment.pixelId }) : BrowserModule,
        BrowserModule,
        ServicesModule,
        BrowserAnimationsModule,
        NgxShimmerLoadingModule,
        LayoutModule
    ],
    providers: [
        TranslationConstants,
        CapacitorHttpProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PjAccountHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AntifraudHttpInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        { provide: LOCALE_ID, useValue: 'pt-br' },
          {
            provide: APP_INITIALIZER,
            useFactory: ApplicationInitializerFactory,
            deps: [ TranslateService, Injector ],
            multi: true
          },
        Title,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
